import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';
import IMAGES from '../assets/index.js';

function About() {
  // Set up intersection observers for animation triggers
  const [leftColRef, leftColInView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const [rightColRef, rightColInView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <div id="about" className="about">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12} 
            className={`mb-4 mb-lg-0 about-image-col ${leftColInView ? 'animate__animated animate__fadeInLeft' : ''}`}
            ref={leftColRef}
          >
            <div className="about-image-container">
              <img 
                src={IMAGES.im} 
                alt="About Nachiketa Yoga" 
                className="img-fluid about-image"
              />
              <div className="experience-badge">
                <span className="years">4+</span>
                <span className="text">Years<br/>Experience</span>
              </div>
            </div>
          </Col>
          
          <Col lg={6} md={12} 
            className={`about-text-col ${rightColInView ? 'animate__animated animate__fadeInRight' : ''}`}
            ref={rightColRef}
          >
            <div className="about-content">
              <div className="section-header">
                <span className="subtitle">About Us</span>
                <h2 className="title">Yoga for Mind, Body & Soul</h2>
              </div>
              
              <div className="about-text">
                <p>
                  At Nachiketa Yoga resided in Bopal, Ahmedabad, we believe that yoga is more than just physical exercise—it's a 
                  journey toward holistic wellbeing. We provide a peaceful sanctuary where 
                  practitioners of all levels can explore the ancient practice of yoga in a supportive, 
                  non-judgmental environment.
                </p>
                
                <p>
                  Founded by experienced teacher with over four years of practice, our classes 
                  blend traditional yoga philosophy with modern teaching approaches to create 
                  transformative experiences that cultivate strength, flexibility, and inner peace.
                </p>
                
                <div className="features">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <i className="fa fa-leaf"></i>
                    </div>
                    <div className="feature-text">
                      <h4>Mindful Practice</h4>
                      <p>Focus on breath awareness and presence in every pose</p>
                    </div>
                  </div>
                  
                  <div className="feature-item">
                    <div className="feature-icon">
                      <i className="fa fa-heart"></i>
                    </div>
                    <div className="feature-text">
                      <h4>Inclusive Community</h4>
                      <p>Welcoming environment for practitioners of all levels</p>
                    </div>
                  </div>
                </div>
                
                <a href="#contact" className="about-cta">Join Our Classes</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;
